// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"490":"981130c2","893":"e5e90ebd"}[chunkId] + ".chunk.js";
};